export default __webpack_public_path__ + "static/media/reddit.dad98495.png";